import { GridColDef } from "@mui/x-data-grid-pro";
import { useHostActivePlayersOnFloor } from "services/api/SWRService";
import { IHostActivePlayer } from "services/models/Host/HostActivePlayer";
import { currencyCol, numberCol, tierCol } from "utils/datagrid-utils";
import { recentActivityCol } from "./ActiveUnHostedPlayersOnFloorTable";
import { PlayerNameCell } from "./PlayerNameCell";
import { GridPaginationProps } from "./helpers";
import { SWRDataGrid } from "./SWRDataGrid";
import { useMobile } from "hooks/Mobile/useMobile";
import { PLAYER_NAME_MIN_WIDTH } from "constants/tables";
import { AppPermissions } from "constants/permissions";
import { useCanAccess } from "@sanmanuel/permissions";

export const filterPanelSx = {
  sx: {
    width: "85vw",
  },
};

export const ActivePlayerOnFloorTable = (props: GridPaginationProps): JSX.Element => {
  const response = useHostActivePlayersOnFloor();
  const isMobile = useMobile();
  const hasStats = useCanAccess(AppPermissions.view.playerStats);

  const protectedStats: GridColDef<IHostActivePlayer>[] = [
    {
      field: "adt90Day",
      headerName: "90-Day ADT",
      minWidth: 120,
      ...currencyCol,
    },
    {
      field: "adw90Day",
      headerName: "90-Day ADW",
      minWidth: 120,
      ...currencyCol,
    },
    {
      field: "avt",
      headerName: "AvT",
      ...numberCol((v) => (v > 12 ? "12+" : v)),
    },
  ];

  const baseCols: GridColDef<IHostActivePlayer>[] = [
    {
      field: "currentTier",
      headerName: "Tier",
      ...tierCol,
    },
    {
      field: "fullName",
      headerName: "Player",
      minWidth: PLAYER_NAME_MIN_WIDTH,
      hideable: false,
      flex: 1,
      renderCell: ({ row }) => <PlayerNameCell {...row} />,
    },
    { field: "hostName", headerName: "Host", minWidth: 160 },
    {
      field: "activityTimestamp",
      headerName: "Recent Activity",
      minWidth: 280,
      ...recentActivityCol,
    },
  ];

  if (hasStats) {
    baseCols.splice(3, 0, ...protectedStats);
  }

  const columns: GridColDef<IHostActivePlayer>[] = baseCols;

  return (
    <SWRDataGrid
      initialState={{
        columns: {
          columnVisibilityModel: {
            currentTier: false,
            activity: false,
            activityLocation: false,
          },
        },
        sorting: {
          sortModel: [{ field: "activityTimestamp", sort: "desc" }],
        },
      }}
      name={"active-players"}
      response={response}
      columns={columns}
      slotProps={{
        columnsPanel: {
          getTogglableColumns: () => ["hostName", "adt90Day", "adw90Day", "avt", "activityTimestamp"], // only allow toggling `age` and `desk` columns
        },
        filterPanel: isMobile ? filterPanelSx : undefined,
      }}
      noRowsMessage="No Active Players on Floor"
      {...props}
    />
  );
};
